// app/(auth)/layout.tsx
import { useLocation } from "react-router-dom";
import { NavLink } from "../components/ui/NavLink";
import Footer from "../components/layouts/common/Footer";


interface AuthLayoutProps {
  children: React.ReactNode;
}

export default function AuthLayout({ children }: AuthLayoutProps) {
  const location = useLocation();
  const pathname = location.pathname;

  return (
    <div className="min-h-screen flex flex-col bg-gradient-to-br from-orange-50 to-white">
      {/* Header fixe avec logo et boutons */}
      <div className="fixed top-0 left-0 right-0 bg-white/95 backdrop-blur-sm border-b border-gray-200 z-50">
        <div className="max-w-7xl mx-auto px-4 md:px-6 py-3 md:py-4">
          <div className="flex items-center justify-between">
            {/* Logo */}
            <NavLink to="/" className="inline-block">
              <img
                src="/logo.png"
                alt="Cabukaka"
                width={100}
                height={38}
                className="object-contain md:w-[120px] md:h-[45px]"
              />
            </NavLink>

            {/* Boutons navigation auth */}
            <div className="flex items-center gap-2 md:gap-4">
              <NavLink
                to="/auth/login"
                className={`px-4 md:px-6 py-2 md:py-2.5 text-sm md:text-base font-semibold rounded-lg transition-all ${
                  pathname === "/auth/login"
                    ? "bg-orange-500 text-white shadow-md shadow-orange-200"
                    : "text-gray-700 hover:bg-orange-50 hover:text-orange-600"
                }`}
              >
                Connexion
              </NavLink>
              <NavLink
                to="/auth/register"
                className={`px-4 md:px-6 py-2 md:py-2.5 text-sm md:text-base font-semibold rounded-lg transition-all ${
                  pathname === "/auth/register"
                    ? "bg-orange-500 text-white shadow-md shadow-orange-200"
                    : "text-gray-700 hover:bg-orange-50 hover:text-orange-600"
                }`}
              >
                Inscription
              </NavLink>
            </div>
          </div>
        </div>
      </div>

      {/* Espace pour compenser le header fixe */}
      <div className="pt-16 md:pt-20"></div>

      {/* Contenu principal centré */}
      <main className="flex-1 flex items-center justify-center px-4 py-8">
        <div className="w-full max-w-md">
          {children}
        </div>
      </main>

      {/* Footer */}
      <Footer />
    </div>
  );
}